import { Box, Button, Card, CardContent, Container, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { PageHead } from '../../components/public/PageHead';

const plans = [
  { name: 'Base', description: 'Per iniziare', features: ['Commesse e rapportini', 'Documenti base', 'Presenze'], cta: 'Contattaci' },
  { name: 'Team', description: 'Per il team', features: ['Tutto in Base', 'Materiali e DDT', 'Mezzi e costi'], cta: 'Contattaci', highlighted: true },
  { name: 'Pro', description: 'Completo', features: ['Tutto in Team', 'Finance e margini', 'Audit e reminder'], cta: 'Contattaci' },
];

export function PricingPage() {
  return (
    <>
      <PageHead
        title="Prezzi"
        description="Prezzi e piani Cantir. Contattaci per una demo e una proposta su misura."
      />
      <Box sx={{ py: 6, px: 2 }}>
        <Container maxWidth="lg">
          <Typography variant="h4" fontWeight={700} align="center" gutterBottom>
            Prezzi
          </Typography>
          <Typography color="text.secondary" align="center" sx={{ mb: 6, maxWidth: 560, mx: 'auto' }}>
            Contattaci per una demo e una proposta adatta alla tua impresa. I piani sotto sono orientativi.
          </Typography>

          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, justifyContent: 'center' }}>
            {plans.map((plan) => (
              <Card
                key={plan.name}
                variant="outlined"
                sx={{
                  flex: { xs: '1 1 100%', md: '1 1 280px' },
                  maxWidth: 320,
                  border: plan.highlighted ? 2 : 0,
                  borderColor: 'primary.main',
                }}
              >
                <CardContent sx={{ p: 3 }}>
                  <Typography variant="h5" fontWeight={700} gutterBottom>{plan.name}</Typography>
                  <Typography color="text.secondary" variant="body2" sx={{ mb: 2 }}>{plan.description}</Typography>
                  <Box component="ul" sx={{ m: 0, pl: 2.5, mb: 3 }}>
                    {plan.features.map((f) => (
                      <li key={f}><Typography variant="body2">{f}</Typography></li>
                    ))}
                  </Box>
                  <Button component={RouterLink} to="/contact" variant={plan.highlighted ? 'contained' : 'outlined'} fullWidth>
                    {plan.cta}
                  </Button>
                </CardContent>
              </Card>
            ))}
          </Box>

          <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 4 }}>
            Nessun impegno. Richiedi una demo per capire quale piano è più adatto a te.
          </Typography>
        </Container>
      </Box>
    </>
  );
}
